module.exports = __webpack_public_path__ + "img/aa-mobile-hover.e63fb5fc.png";